
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 9.333c.369 0 .667.298.667.667v2.666a.666.666 0 00.667.667h9.333a.666.666 0 00.667-.667V10a.667.667 0 011.333 0v2.666a2 2 0 01-2 2H3.334a2 2 0 01-2-2V10c0-.369.298-.667.667-.667zM7.53 1.528c.26-.26.682-.26.942 0l3.333 3.334a.667.667 0 01-.942.942L8 2.942 5.139 5.804a.667.667 0 11-.943-.942l3.333-3.334z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 1.333c.369 0 .667.298.667.667v8a.667.667 0 11-1.333 0V2c0-.369.298-.667.667-.667z"}})])
          )
        }
      }
    